<template>
    <div class="index notranslate">
        <!-- appbar -->
        <v-header :is-seft="1"></v-header>

        <!-- cart content -->
        <mu-container class="content" style="padding-left:0px;padding-right:0px;overflow-y:auto;padding-bottom:60px;" v-show="!showOrderTip">
            <div class="ower">
                <span class="badge-num" :class="{select:current==-1}" @click="selectOwerCartlist(-1,null)">{{$t('orderList.all')}}</span>
                <span class="badge-num" :class="{select:index==current}" @click="selectOwerCartlist(index,val)" :key="index" v-for="(val, key, index) in cartOwerData">{{key.replace(/\"/g,"")}}</span>
            </div>
            <div class="cart-box" style="margin-top:5px;" v-for="(val, key, index) in cartShowData" :key="index">
                <mu-list>
                    <mu-list-item style="height:36px;" v-if="key!='null'">
                        <mu-list-item-content>
                            <mu-list-item-title class="table-info-list-title">{{key.replace(/\"/g,"")}}</mu-list-item-title>
                        </mu-list-item-content>
                    </mu-list-item>
                    <mu-divider shallow-inset v-if="key!='null'"></mu-divider>
                    <mu-list-item style="height:40px;margin:20px auto;" v-for="item,index in val" :key="index">
                        <mu-flex>
                            <mu-avatar style="width: 60px !important;">
                                <img :src="getImgUrl(item.foodImage,100)" style="border-radius:0;"/>
                            </mu-avatar>
                        </mu-flex>
                        <mu-list-item-content>
                            <div style="margin-left: 5px;">
                                <div style="float:left;">
                                    <div style="font-size:12px;height:24px;line-height:24px;">
                                        {{item.foodName}}
                                    </div>
                                    <div style="font-size:12px;" v-if="item.decideName!=null && item.decideName!=''">
                                        {{item.decideName}}
                                    </div>
                                    <div>
                                        <span class="now">{{ item.price }} {{seller.unit}}</span>
                                        <span>x {{ item.quantity }}</span>
                                    </div>
                                </div>
                                <div class="cart-opration" style="float:right;">
                                    <span class="now"> {{item.quantity * item.price}} {{seller.unit}}</span>
                                </div>
                            </div>
                        </mu-list-item-content>
                    </mu-list-item>
                </mu-list>
            </div>
            <mu-list>
                <mu-list-item style="height:40px;margin:5px auto;">
                    <mu-list-item-content>
                        <div style="float:right;font-size:16px;font-weight:600;">{{$t('orderList.total')}}: <span class="now" style="font-size:16px;">{{total}} {{seller.unit}}</span></div>
                    </mu-list-item-content>
                </mu-list-item>
            </mu-list>
            <div>
                <mu-expansion-panel v-for="(value, k, i) in cartBuffetShowData" style="width:100%;" :key="i" :expand="getExpand(i)" :zDepth="1">
                    <div slot="header" style="width:100%;">{{getOrderTimes(i+1)}} </div>
                    <div class="cart-box" style="margin-top:5px;" v-for="(val, key, index) in getTypeGroup(value)" :key="index">
                        <mu-list>
                            <mu-list-item style="height:36px;">
                                <mu-list-item-content>
                                    <mu-list-item-title class="table-info-list-title">{{key.replace(/\"/g,"")}}</mu-list-item-title>
                                </mu-list-item-content>
                            </mu-list-item>
                            <mu-divider shallow-inset></mu-divider>
                            <mu-list-item style="height:40px;margin:20px auto;" v-for="item,index1 in val" :key="index1">
                                <mu-flex>
                                    <mu-avatar style="width: 60px !important;">
                                        <img :src="getImgUrl(item.foodImage,100)" style="border-radius:0;"/>
                                    </mu-avatar>
                                </mu-flex>
                                <mu-list-item-content>
                                    <div style="margin-left: 5px;">
                                        <div style="float:left;">
                                            <div style="font-size:12px;height:24px;line-height:24px;">
                                                {{item.foodName}}
                                            </div>
                                            <div style="font-size:12px;height:24px;line-height:24px;" v-if="item.decideName!=null && item.decideName!=''">
                                                {{item.decideName}}
                                            </div>
                                        </div>
                                        <div class="cart-opration" style="float:right;">
                                            <span class="now">x {{item.quantity}} </span>
                                        </div>
                                    </div>
                                </mu-list-item-content>
                            </mu-list-item>
                        </mu-list>
                    </div>
                </mu-expansion-panel>
            </div>

            <mu-list>
                <mu-list-item style="height:60px;margin:5px auto;">
                    <mu-list-item-content>
                    </mu-list-item-content>
                </mu-list-item>
            </mu-list>


            <div class="oprations">

                <!--<div class="oprations-btn">
                <div class="oprations-back" @click="refresh">{{$t('orderList.refresh')}}</div>
            </div>-->
                <div class="oprations-btn">
                    <div class="oprations-next enough" @click="jumpHome">{{$t('orderList.home')}}</div>
                </div>
            </div>

            <!--<mu-button large fab color="green" class="btn-home" @click="jumpHome">
            <div>
                <div>
                    <mu-icon value="reply"></mu-icon>
                </div>
                <div>
                    Reorder
                </div>
            </div>
        </mu-button>-->
        </mu-container>
        <div style="width: 100%; background: #fff; padding: 20px;text-align:center;padding-top:60px;" v-show="showOrderTip">
            <mu-flex class="flex-wrapper" justify-content="center">
                <div style="font-size:16px;font-weight:600;color:#DA5B3A;">{{$t('buffet.nullOrder')}}</div>
            </mu-flex>
            <mu-flex class="flex-wrapper" justify-content="center">
                <div style="width: 100%; text-align: center; margin-top: 30px;"><mu-button color="success" @click="jumpBack" style="text-transform:unset;">{{$t('orderList.return')}}</mu-button></div>
            </mu-flex>
        </div>


        <mu-drawer :open.sync="open" :docked="docked" :right="true" width="100%">
            <div style="font-size: 20px; font-weight: 500;text-align: center;margin-top: 5px; ">{{$t('orderList.info')}}</div>
            <mu-icon value="close" size="20" class="close-icon" @click="open = false"></mu-icon>
            <mu-form :model="tableOrderInfo" class="mu-demo-form" label-position="right" style="width:90%;margin:0 auto;margin-top:10px;">
                <mu-form-item prop="TableName" label="Table" class="order-list-item">
                    <mu-text-field v-model="tableOrderInfo.tableName" readonly></mu-text-field>
                </mu-form-item>
                <mu-form-item prop="Name" :label="$t('login.name')" class="order-list-item">
                    <mu-text-field v-model="tableOrderInfo.name" readonly></mu-text-field>
                </mu-form-item>
                <mu-form-item :label="$t('login.telephone')" prop="Telephone" class="order-list-item">
                    <mu-text-field v-model="tableOrderInfo.telephone" readonly></mu-text-field>
                </mu-form-item>

                <mu-form-item :label="$t('login.number')" prop="Adult" class="order-list-item">
                    <mu-text-field v-model="tableOrderInfo.adult" readonly></mu-text-field>
                </mu-form-item>

                <mu-form-item :label="$t('login.beginTime')" prop="OrderTime" class="order-list-item">
                    <mu-text-field v-model="tableOrderInfo.orderTime" readonly></mu-text-field>
                </mu-form-item>
            </mu-form>
            <mu-list>
                <mu-list-item button @click="menuAddPackageLink" v-if="isSeft==1">
                    <mu-list-item-action style="min-width:36px;">
                        <mu-icon value="add_circle_outline" color="orange"></mu-icon>
                    </mu-list-item-action>
                    <mu-list-item-title>{{$t('orderList.morePeople')}}</mu-list-item-title>
                </mu-list-item>
            </mu-list>
        </mu-drawer>

        <mu-dialog :title="$t('orderList.orderChangeTip')" width="360" :open.sync="openOrderChange" :overlay-close="false" :esc-press-close="false">
            {{$t('common.orderstatechange')}}
            <mu-button slot="actions" flat color="primary" @click="jumpOrderChange" style="color: #da5b3a;"> {{$t('common.sure')}}</mu-button>
        </mu-dialog>
    </div>

    
</template>
<script>
    import header from '../components/Header';
    export default {
        name: 'OrderBill',
        data() {
            return {
                title: 'Order bill',
                seller: {},
                showFullScreen: true,
                tableOrderInfo: {},
                total:0,
                cartList: [],
                groupCartList: [],
                groupCartBuffetList: [],
                cartShowData: {},
                cartBuffetShowData: {},
                showOrderTip: false,
                isSeft: 0,
                docked: false,
                open: false,
                current: -1,
                cartOwerData: {},
                openOrderChange: false,
                timer: null
            }
        },
        components: {
            'v-header': header
        },
        mounted() {
            if ("undefined" != typeof api) {
                this.showFullScreen = false;
            }
            this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
            this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
            this.isSeft = this.$route.query.isSeft;
            this.getTitle();
            this.getOrderList();

            if (this.timer != null) {
                clearInterval(this.timer);
            }
            // this.timer = setInterval(() => {
            //     this.checkOrder()
            // }, 5000);
            //this.$once('hook:beforeDestroy', () => {
            //    clearInterval(this.timer)
            //})
        },
        methods: {
            jumpOrderChange() {
                this.openOrderChange = false;
                this.$router.push({
                    path: '/result'
                })
            },
            checkOrder() {
                if(this.isSeft==0){
                    return;
                }
                let param = {
                    tableName: this.tableOrderInfo.tableName,
                    restaurantId: this.tableOrderInfo.restaurantId
                };
                this.$get('QRCodeOrder/GetUnpayOrderMainByTableName', param)
                    .then(response => {
                        if (response.code==200) {
                            var data = response.data;
                            if (data == null || data == '') {
                                window.clearTimeout(this.timer);
                                this.openOrderChange = true;
                            }
                        }
                    });
            },
            menuAddPackageLink() {
                this.open = false;
                this.docked = true;
                this.$router.push({
                    path: '/buffetSelect'
                })
            },
            jumpHome() {
                if (this.isSeft == 0) {
                            this.$router.push({ path: '/goodsMain' });
                        }
                        else {
                            this.$router.push({ path: '/buffet' });
                        }
            },
            getOrderList() {
                this.total = 0;
                let param = {
                    tableName: this.tableOrderInfo.tableName,
                    restaurantId: this.tableOrderInfo.restaurantId
                };
                this.$get('QRCodeOrder/GetUnpayOrderMainByTableName', param)
                    .then(response => {
                        if (response.code == 200) {
                            var data = response.data;
                            if (data == null || data == '') {
                                this.showOrderTip = true;
                                return;
                            }
                            this.tableOrderInfo.orderTime =  data.orderDay.replace('/Date(', '').replace(')/', '');
                            this.$get('QRCodeOrder/GetQRcodeOrderList', { orderId: data.orderId })
                                .then(result => {
                                    if (result.code == 200) {
                                        this.cartList = result.data;
                                        if (this.cartList.length == 0) {
                                            this.cartShowData = [];
                                            this.showOrderTip = true;
                                            return;
                                        }
                                        this.total = 0;
                                        this.showOrderTip = false;
                                        for (var i = 0; i < this.cartList.length; i++) {
                                            if(this.cartList[i].isSeft==0){
                                                this.total += (this.cartList[i].quantity * this.cartList[i].price);
                                            }
                                        }
                              
                                        this.cartOwerData = this.groupBy(this.cartList, (cart) => {
                                            return cart.createUser
                                        });
                                
                                        var map = {},
                                        dest = [];
                                        for (var i = 0; i < this.cartList.length; i++) {
                                            var ai = this.cartList[i];
                                            var isHas = false;
                                                for (var j = 0; j < dest.length; j++) {
                                                    var dj = dest[j];
                                                    if (dj.foodId == ai.foodId && dj.decideName == ai.decideName &&dj.batch == ai.batch) {
                                                        isHas=true;
                                                        dest.splice(j, 1);
                                                        dest.push({
                                                            orderId:ai.orderId,
                                                            foodId:ai.foodId,
                                                            foodName:ai.foodName,
                                                            decideName:ai.decideName,
                                                            price:ai.price,
                                                            foodDiscount: ai.foodDiscount,
                                                            foodImage: ai.foodImage,
                                                            foodTypeName: ai.foodTypeName,
                                                            quantity: ai.quantity + dj.quantity,
                                                            isSeft: ai.isSeft,
                                                            batch: ai.batch
                                                        });
                                                        break;
                                                    }
                                            }
                                            if (!isHas) {
                                                dest.push({
                                                    orderId: ai.orderId,
                                                    foodId: ai.foodId,
                                                    foodName: ai.foodName,
                                                    decideName:ai.decideName,
                                                    price: ai.price,
                                                    foodDiscount: ai.foodDiscount,
                                                    foodImage: ai.foodImage,
                                                    foodTypeName: ai.foodTypeName,
                                                    quantity: ai.quantity,
                                                    isSeft: ai.isSeft,
                                                    batch: ai.batch
                                                });
                                            }
                                        }
                                        this.groupCartList = [];
                                        this.groupCartBuffetList = [];
                                        for (var q = 0; q < dest.length; q++) {
                                            if (dest[q].isSeft == 0) {
                                                this.groupCartList.push(dest[q]);
                                            }
                                            else {
                                                this.groupCartBuffetList.push(dest[q]);
                                            }
                                        }
                                   
                                        this.cartShowData = this.groupBy(this.groupCartList, (cart) => {
                                            return cart.foodTypeName
                                        });
                                        this.cartBuffetShowData = this.groupBy(this.groupCartBuffetList, (cart) => {
                                            return cart.batch
                                        });
                                    }
                                    else {
                                        this.showOrderTip = true;
                                    }
                                });
                        }
                    });
            },
            selectOwerCartlist(index, list) {
                this.current = index;
                let groupCartList = [];
                let groupCartBuffetList = [];
                if (list != null) {
                    for (var q = 0; q < list.length; q++) {
                        if (list[q].isSeft == 0) {
                            groupCartList.push(list[q]);
                        }
                        else {
                            groupCartBuffetList.push(list[q]);
                        }
                    }
                }
                else {
                    groupCartList = this.groupCartList;
                    groupCartBuffetList = this.groupCartBuffetList;
                }
                if (groupCartList.length > 0) {
                    var total = 0;
                    groupCartList.forEach(function (item) {
                        total += Math.round(item.quantity * item.price);
                    });
                    this.total = total;

                    this.cartShowData = this.groupBy(groupCartList, (cart) => {
                        return cart.foodTypeName
                    });
                }
                else {
                    this.cartShowData = [];
                }
                if (groupCartBuffetList.length > 0) {
                    this.cartBuffetShowData = this.groupBy(groupCartBuffetList, (cart) => {
                        return cart.batch
                    });
                }
                else {
                    this.cartBuffetShowData = [];
                }
            },
            getTypeGroup(val) {
               return this.groupBy(val, (cart) => {
                    return cart.foodTypeName
               });
            },
            getOrderTimes(times) {
                let txt = '';
                if (times == 1) {
                    txt = this.$t("orderList.frist")
                }
                else if (times == 2) {
                    txt = this.$t("orderList.second")
                }
                else if (times == 3) {
                    txt = this.$t("orderList.third")
                }
                else if (times == 4) {
                    txt = this.$t("orderList.fourth")
                }
                else {
                    txt = this.$t("orderList.moreth", { times: times });
                }
                return txt;
            },
            getExpand(index) {
                var count = 0;
                for (var i in this.cartBuffetShowData) {
                    count++;
                }
                if ((index+1) == count) {
                    return true;
                }
                return false;
            },
            groupBy(list, fn) {
                const groups = {};
                list.forEach(function (o) {
                    const group = JSON.stringify(fn(o));
                    groups[group] = groups[group] || [];
                    groups[group].push(o);
                });
                return groups;
            },
            getImgUrl(image,w=0) {
                if (image == undefined || image == 'undefined' || image == null|| image == '') {
                    return '../static/img/default.png';
                }
                if(w==0){
                    return this.global.baseUrl + "uploads/" + image
                }
                return  this.global.baseUrl+"api/images/"+w+"/"+ image
            },
            refresh() {
                this.getOrderList();
                this.$toast.success('Refresh successfully!');
            },
            jumpIndex() {
                if (this.timeOutCheck()) {
                    this.$router.push({ path: '/buffet' });
                }
            },
            timeOutCheck() {
                let that = this;
                var time = window.localStorage.getItem('timeOut');
                if (time != undefined && time != null && time != "") {
                    var dateTimeStamp = new Date(time.replace(/-/g, '/')).getTime();
                    var now = new Date().getTime();
                    var diffValue = now - dateTimeStamp;
                    var minute = 1000 * 60;
                    var minC = diffValue / minute;
                    if (parseInt(minC) >= 120) {
                        this.$alert(this.$t("common.pageInvalid"), this.$t("common.alert"), {
                            type: 'warning', okLabel: this.$t("common.ok"),
                        }).then(function (result, value) {
                            that.$router.push({
                                path: '/error'
                            })
                        });
                        return false;
                    }
                    return true;
                }
                this.$alert(this.$t("common.pageInvalid"), this.$t("common.alert"), {
                    type: 'warning', okLabel: this.$t("common.ok"),
                }).then(function (result, value) {
                    that.$router.push({
                        path: '/error'
                    })
                });
                return false;
            },
            jumpBack() {
                if (this.timeOutCheck()) {
                    if (this.$route.query.isSeftPay != undefined && this.$route.query.isSeftPay != null) {
                        if ((this.isSeft == 0 && this.$route.query.isSeftPay == 1) || this.isSeft == 1) {
                            this.$router.push({ path: '/buffet' });
                        }
                        else {
                            this.$router.push({ path: '/buffet' });
                        }
                    }
                    else {
                        this.$router.go(-1);
                    }
                }
            },
            getTitle() {
                this.title = 'Bill list';
            },
            //getPath() {
            //},
            openDrawer() {
                this.open = !this.open;
                this.docked = false;
            },
        },
        activated() {
            this.getOrderList();
        },
        //  watch: {
        //    '$route': 'getPath'
        //},
    }
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
/deep/ .mu-expansion-toggle-btn.mu-button{
    margin-right:0px !important;
}
    .nav-title {
        text-align: center;
        font-size:18px;
    }
    .mu-list {
        padding: 5px 0;
    }
    .mu-button {
        text-transform:unset;
    }
    .mu-button .mu-icon-left {
        margin-right: 3px;
    }
    .mu-raised-button .mu-button-wrapper {
        padding: 0;
    }
    .material-icons {
        font-size: 16px;
    }
    .order-list-item {
        margin-bottom: 0px;
    }
    .content {
        width: 100%;
        height: 100%;
        position: absolute;
        padding-top:10px;
    }

    .cart-box {
        position: relative;
        margin: auto;
        background-color:#fff;
        background-size: cover;
        overflow-y:unset;
    }

    .table-info-keywords {
        color: #e53935;
        font-size: 18px;
        font-weight: 600;
        margin-left: 10px;
    }
    .table-info-list-title {
        text-align: center;
        font-size: 16px;
        color: #4fc3f7;
    }
    .cart-opration {
        float: right; 
    }

    .cart-opration-btn {
        width: 32px;
        height: 32px;
        min-width: unset;
        font-size: 16px;
        color: #e53935;
        padding:0px;
    }

    .cart-opration-quantity {
        width: 36px;
        height: 32px;
        min-width: unset;
        top: -3px;
    }
    .btn-refresh {
        position: fixed;
        right:10px;
        background-color: #757575 !important;
        z-index:10;
    }
    .btn-menu {
        position: fixed;
        bottom: 10px;
        left: 10px;
        background-color: #757575 !important;
    }
    .btn-continue {
        position: fixed;
        bottom: 10px;
        background-color: #757575 !important;
        left: 41%;
    }
    .btn-order {
        position: fixed;
        bottom: 10px;
        right: 10px
    }
    .now {
        font-size: 12px;
        color: #f01414;
        font-weight: 700;
        line-height: 24px;
        margin-right: 8px;
    }
    .old {
        font-size: 12px;
        text-decoration: line-through;
        color: #93999f;
        font-weight: 700;
        line-height: 24px;
    }
    .seal {
        max-width: 120px;
        margin: auto;
        -webkit-backface-visibility: hidden;
        float: left;
    }

    .stamp {
        position: relative;
    }
        .stamp:after {
            border: solid 0.1em #d00;
            border-radius: .2em;
            color: #d00;
            content: 'Order';
            font-size: 16px;
            font-weight: bold;
            line-height: 1;
            opacity: 0;
            position: absolute;
            padding: .1em .5em;
            margin: 0 auto;
            top: 2px;
            text-transform: uppercase;
            opacity: 0;
            transform-origin: 50% 50%;
            transform: rotate(-2deg) scale(5);
            transition: all 0.3s cubic-bezier(0.6, 0.04, 0.98, 0.335);
        }

    .loaded .stamp:after {
        opacity: .75;
        transform: rotate(-5deg) scale(1);
        z-index: 101;
    }
    .btn-home {
        position: fixed;
        bottom:10px;
        left: 10px;
        background-color: #da5b3a !important;
    }
    .close-icon {
        position: absolute;
        top: 10px;
        right: 10px;
    }
    .ower {
        position: relative;
        z-index: 9;
        padding: 10px;
        background-color: #fff;
    }

    .badge-num {
        float: left;
        width: 60px;
        height: 32px;
        margin-right: 5px;
        margin-bottom: 5px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 0 6px;
        line-height: 1.5;
        font-size: 14px;
        font-style: normal;
        background-color: #bdbdbd;
        color: #fff;
        border-radius: 3px;
        overflow: hidden;
    }

    .select {
        background-color: rgb(218, 91, 58);
    }

    .oprations {
        position: fixed;
        bottom: 0;
        right: 0;
    }

        .oprations .oprations-btn {
            -webkit-box-flex: 0;
            -ms-flex: 0 0 105px;
            flex: 0 0 105px;
            width: 105px;
            float: left;
        }

            .oprations .oprations-btn .oprations-back {
                height: 48px;
                line-height: 48px;
                font-size: 12px;
                font-weight: 700;
                text-align: center;
                background-color: #bdbdbd;
                color: #fff;
                float: right;
                width: 100%;
            }

            .oprations .oprations-btn .oprations-next {
                height: 48px;
                line-height: 48px;
                font-size: 12px;
                font-weight: 700;
                text-align: center;
                float: right;
                width: 160px;
            }

                .oprations .oprations-btn .oprations-next.not-enough {
                    background: #bdbdbd;
                }

                .oprations .oprations-btn .oprations-next.enough {
                    background: #da5b3a;
                    color: #fff;
                }
</style>



// WEBPACK FOOTER //
// src/components/OrderList.vue